"use client";
import { Swiper, SwiperClass, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./swiperhighlights.scss";
import HighlightsCard from "../../Cards/HighlightsCard/HighlightsCard";
import {
  ICardResponse,
  IHighlightsResponseModel,
  TOptionalType,
} from "../../../core/models";

export interface ISwiperHighligtsProps {
  props?: TOptionalType<IHighlightsResponseModel>;
}

const SwiperHighlights = ({ props }: ISwiperHighligtsProps) => {
  const pushEventForSlideChange = (swiper: SwiperClass) => {
    if (window && (window as any)["ReactNativeWebView"]) {
      (window as any)["ReactNativeWebView"].postMessage(
        JSON.stringify({
          message: "eventLogForCountly",
          eventName: "Ana Sayfa",
          eventSegment: {
            sonHaberler: props?.comp_spotlist.cards.at(swiper.activeIndex)?.title,
          },
          actionType: "event",
        })
      );
    }
  };

  return (
    <div className="swiper-highlights">
      <div className="swiper-highlights__head">
        <h2>{props?.comp_spotlist.title}</h2>
        <div className="swiper-highlights__pagination"></div>
      </div>
      <div className="swiper-highlights__cards">
        <Swiper
          spaceBetween={16}
          slidesPerView={1}
          modules={[Pagination]}
          onSlideChange={pushEventForSlideChange}
          onSwiper={pushEventForSlideChange}
          pagination={{
            el: ".swiper-highlights__pagination",
            type: "bullets",
            clickable: true,
          }}
          speed={800}
        >
          {props?.comp_spotlist.cards.map(
            (card: ICardResponse, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <HighlightsCard card={card}></HighlightsCard>
                </SwiperSlide>
              );
            }
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default SwiperHighlights;
